import { Directive } from '@angular/core';

@Directive({
  selector: '[qpointContentContainerBottom]',
  standalone: true
})
export class ContentContainerBottomDirective {
}
